var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	32995: () => (loadSingletonVersion("default", "react", false, [1,17,0,2], () => (__webpack_require__.e(7810).then(() => (() => (__webpack_require__(77810))))))),
	33444: () => (loadStrictVersion("default", "prop-types", false, [1,15,8,1], () => (__webpack_require__.e(5826).then(() => (() => (__webpack_require__(75826))))))),
	86717: () => (loadSingletonVersion("default", "react-dom", false, [1,17,0,2], () => (__webpack_require__.e(2483).then(() => (() => (__webpack_require__(22483))))))),
	11975: () => (loadStrictVersion("default", "@mui/utils", false, [4,5,15,20], () => (__webpack_require__.e(6342).then(() => (() => (__webpack_require__(63961))))))),
	68300: () => (loadStrictVersion("default", "clsx", false, [1,2,0,0], () => (__webpack_require__.e(1358).then(() => (() => (__webpack_require__(91358))))))),
	68565: () => (loadSingletonVersion("default", "@mui/system", false, [0], () => (Promise.all([__webpack_require__.e(7787), __webpack_require__.e(4198), __webpack_require__.e(4918), __webpack_require__.e(1747)]).then(() => (() => (__webpack_require__(4198))))))),
	54007: () => (loadSingletonVersion("default", "@azure/msal-browser", false, [1,3,9,0], () => (__webpack_require__.e(7244).then(() => (() => (__webpack_require__(37244))))))),
	9674: () => (loadSingletonVersion("default", "react-redux", false, [1,8,0,0], () => (Promise.all([__webpack_require__.e(1032), __webpack_require__.e(6717)]).then(() => (() => (__webpack_require__(71032))))))),
	22602: () => (loadStrictVersion("default", "axios", false, [2,0,26,1], () => (__webpack_require__.e(3159).then(() => (() => (__webpack_require__(63159))))))),
	29273: () => (loadStrictVersion("default", "qs", false, [1,6,11,0], () => (Promise.all([__webpack_require__.e(7691), __webpack_require__.e(2634)]).then(() => (() => (__webpack_require__(97691))))))),
	43572: () => (loadSingletonVersion("default", "@reduxjs/toolkit", false, [1,1,8,1], () => (__webpack_require__.e(7740).then(() => (() => (__webpack_require__(27740))))))),
	81682: () => (loadStrictVersion("default", "uuid", false, [1,9,0,0], () => (__webpack_require__.e(3725).then(() => (() => (__webpack_require__(93725))))))),
	11552: () => (loadSingletonVersion("default", "@mui/material", false, [4,5,11,16], () => (Promise.all([__webpack_require__.e(3671), __webpack_require__.e(7787), __webpack_require__.e(3679), __webpack_require__.e(4918)]).then(() => (() => (__webpack_require__(83679))))))),
	14654: () => (loadSingletonVersion("default", "@azure/msal-react", false, [1,2,0,11], () => (__webpack_require__.e(8355).then(() => (() => (__webpack_require__(38355))))))),
	22881: () => (loadSingletonVersion("default", "i18next", false, [1,21,9,0], () => (__webpack_require__.e(6984).then(() => (() => (__webpack_require__(46984))))))),
	47502: () => (loadSingletonVersion("default", "i18next-browser-languagedetector", false, [1,6,1,4], () => (__webpack_require__.e(8098).then(() => (() => (__webpack_require__(38098))))))),
	52876: () => (loadStrictVersion("default", "@modusx-shared/ui-lib-modus-x", false, [4,2,54,0], () => (Promise.all([__webpack_require__.e(3671), __webpack_require__.e(6661), __webpack_require__.e(310)]).then(() => (() => (__webpack_require__(46661))))))),
	64628: () => (loadStrictVersion("default", "react-router-dom", false, [1,5,2,0], () => (__webpack_require__.e(8772).then(() => (() => (__webpack_require__(88772))))))),
	68443: () => (loadStrictVersion("default", "react-helmet-async", false, [1,1,3,0], () => (__webpack_require__.e(4179).then(() => (() => (__webpack_require__(64179))))))),
	70143: () => (loadSingletonVersion("default", "@mui/styles", false, [0], () => (Promise.all([__webpack_require__.e(5655), __webpack_require__.e(8089)]).then(() => (() => (__webpack_require__(15655))))))),
	90589: () => (loadStrictVersion("default", "react-i18next", false, [1,11,18,3], () => (__webpack_require__.e(4313).then(() => (() => (__webpack_require__(6694))))))),
	97326: () => (loadSingletonVersion("default", "i18next-http-backend", false, [1,2,1,0], () => (__webpack_require__.e(3784).then(() => (() => (__webpack_require__(77935))))))),
	70310: () => (loadSingletonVersion("default", "@emotion/react", false, [4,11,10,8], () => (Promise.all([__webpack_require__.e(7738), __webpack_require__.e(8412)]).then(() => (() => (__webpack_require__(58412))))))),
	11650: () => (loadStrictVersion("default", "@mui/styled-engine", false, [4,5,15,14], () => (Promise.all([__webpack_require__.e(7738), __webpack_require__.e(310), __webpack_require__.e(7106), __webpack_require__.e(5708)]).then(() => (() => (__webpack_require__(5708))))))),
	93591: () => (loadStrictVersion("default", "clsx", false, [1,2,0,0], () => (__webpack_require__.e(601).then(() => (() => (__webpack_require__(10601))))))),
	7106: () => (loadSingletonVersion("default", "@emotion/styled", false, [4,11,10,8], () => (__webpack_require__.e(4578).then(() => (() => (__webpack_require__(24578))))))),
	5983: () => (loadStrictVersion("default", "clsx", false, [1,2,0,0], () => (__webpack_require__.e(4093).then(() => (() => (__webpack_require__(4093))))))),
	99219: () => (loadStrictVersion("default", "jss", false, [1,10,10,0], () => (__webpack_require__.e(3266).then(() => (() => (__webpack_require__(83266))))))),
	91747: () => (loadStrictVersion("default", "@mui/private-theming", false, [4,5,15,20], () => (__webpack_require__.e(2091).then(() => (() => (__webpack_require__(34472)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"310": [
		70310
	],
	"1682": [
		81682
	],
	"1747": [
		91747
	],
	"1975": [
		11975
	],
	"2904": [
		9674,
		22602,
		29273,
		43572
	],
	"2995": [
		32995
	],
	"3444": [
		33444
	],
	"4007": [
		54007
	],
	"4918": [
		11650,
		93591
	],
	"6717": [
		86717
	],
	"7106": [
		7106
	],
	"7664": [
		68300,
		68565
	],
	"8089": [
		5983,
		99219
	],
	"8935": [
		11552,
		14654,
		22881,
		47502,
		52876,
		64628,
		68443,
		70143,
		90589,
		97326
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}